{
  "countries": {
    "usa": {
      "name": "United States",
      "slug": "usa",
      "currency": "USD",
      "currency_symbol": "$",
      "tax_system": "federal_state_local",
      "federal_tax": {
        "brackets": [
          { "min": 0, "max": 11000, "rate": 0.10 },
          { "min": 11001, "max": 44725, "rate": 0.12 },
          { "min": 44726, "max": 95375, "rate": 0.22 },
          { "min": 95376, "max": 182100, "rate": 0.24 },
          { "min": 182101, "max": 231250, "rate": 0.32 },
          { "min": 231251, "max": 578125, "rate": 0.35 },
          { "min": 578126, "max": 999999999, "rate": 0.37 }
        ],
        "standard_deduction": 13850,
        "social_security_rate": 0.062,
        "social_security_cap": 160200,
        "medicare_rate": 0.0145
      },
      "states": {
        "nj": {
          "name": "New Jersey",
          "slug": "nj",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 20000, "rate": 0.014 },
              { "min": 20001, "max": 35000, "rate": 0.0175 },
              { "min": 35001, "max": 40000, "rate": 0.035 },
              { "min": 40001, "max": 75000, "rate": 0.05525 },
              { "min": 75001, "max": 500000, "rate": 0.0637 },
              { "min": 500001, "max": 1000000, "rate": 0.0897 },
              { "min": 1000001, "max": 999999999, "rate": 0.1075 }
            ]
          },
          "cities": {
            "wood-ridge": {
              "name": "Wood-Ridge",
              "slug": "wood-ridge",
              "coordinates": { "lat": 40.8501, "lon": -74.0879 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 142,
              "content": {
                "intro": "Wood-Ridge, a charming borough in Bergen County, offers residents proximity to New York City while maintaining a suburban lifestyle. Understanding your take-home pay is crucial in this high-cost-of-living area.",
                "fun_fact": "Wood-Ridge is home to approximately 10,000 residents and features excellent schools and parks, making it a popular choice for families working in the tri-state area.",
                "hiring_stats": "The median household income in Wood-Ridge is approximately $95,000, with many residents commuting to Manhattan for work in finance, technology, and healthcare sectors."
              },
              "nearby_cities": ["hackensack", "jersey-city", "newark"]
            },
            "hackensack": {
              "name": "Hackensack",
              "slug": "hackensack",
              "coordinates": { "lat": 40.8859, "lon": -74.0435 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 138,
              "content": {
                "intro": "Hackensack, the county seat of Bergen County, is a thriving urban center with diverse employment opportunities and excellent transportation links to New York City.",
                "fun_fact": "Hackensack is home to major medical centers and corporate headquarters, making it a significant employment hub in northern New Jersey.",
                "hiring_stats": "With a median household income of $88,000, Hackensack offers opportunities in healthcare, retail, and professional services."
              },
              "nearby_cities": ["wood-ridge", "jersey-city", "newark"]
            },
            "jersey-city": {
              "name": "Jersey City",
              "slug": "jersey-city",
              "coordinates": { "lat": 40.7178, "lon": -74.0431 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 152,
              "content": {
                "intro": "Jersey City, the second-largest city in New Jersey, sits directly across the Hudson River from Manhattan. Its booming waterfront development and diverse neighborhoods make it a top destination for professionals seeking urban living with slightly lower costs than NYC.",
                "fun_fact": "Jersey City has been nicknamed 'Wall Street West' due to the growing number of financial firms relocating from Manhattan to its waterfront district along Exchange Place.",
                "hiring_stats": "The median household income in Jersey City is approximately $82,000, with strong employment in financial services, technology, logistics, and healthcare."
              },
              "nearby_cities": ["wood-ridge", "hackensack", "newark"]
            },
            "newark": {
              "name": "Newark",
              "slug": "newark",
              "coordinates": { "lat": 40.7357, "lon": -74.1724 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 118,
              "content": {
                "intro": "Newark, New Jersey's largest city, is undergoing a major economic renaissance. Home to Newark Liberty International Airport and a growing arts district, the city offers affordable living with excellent transit access to New York City.",
                "fun_fact": "Newark's Ironbound District is famous for its Portuguese and Brazilian restaurants and is considered one of the best food neighborhoods in the entire tri-state area.",
                "hiring_stats": "The median household income in Newark is approximately $40,000, with major employers in transportation, healthcare, education, and insurance sectors."
              },
              "nearby_cities": ["jersey-city", "wood-ridge", "hackensack"]
            }
          }
        },
        "ny": {
          "name": "New York",
          "slug": "ny",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 8500, "rate": 0.04 },
              { "min": 8501, "max": 11700, "rate": 0.045 },
              { "min": 11701, "max": 13900, "rate": 0.0525 },
              { "min": 13901, "max": 80650, "rate": 0.055 },
              { "min": 80651, "max": 215400, "rate": 0.06 },
              { "min": 215401, "max": 1077550, "rate": 0.0685 },
              { "min": 1077551, "max": 5000000, "rate": 0.0965 },
              { "min": 5000001, "max": 25000000, "rate": 0.103 },
              { "min": 25000001, "max": 999999999, "rate": 0.109 }
            ]
          },
          "cities": {
            "manhattan": {
              "name": "Manhattan",
              "slug": "manhattan",
              "coordinates": { "lat": 40.7831, "lon": -73.9712 },
              "local_tax_rate": 0.03876,
              "cost_of_living_index": 187,
              "content": {
                "intro": "Manhattan, the heart of New York City, is one of the world's premier business and cultural centers. With the highest cost of living in the nation, understanding your net income is essential for financial planning.",
                "fun_fact": "Manhattan is home to Wall Street, Broadway, and countless Fortune 500 companies, offering unparalleled career opportunities across all industries.",
                "hiring_stats": "The median household income in Manhattan exceeds $125,000, with significant employment in finance, technology, media, and professional services."
              },
              "nearby_cities": ["brooklyn", "buffalo"]
            },
            "brooklyn": {
              "name": "Brooklyn",
              "slug": "brooklyn",
              "coordinates": { "lat": 40.6782, "lon": -73.9442 },
              "local_tax_rate": 0.03876,
              "cost_of_living_index": 172,
              "content": {
                "intro": "Brooklyn, the most populous borough of New York City, blends historic brownstone neighborhoods with a thriving creative economy. From DUMBO's tech startups to Williamsburg's cultural scene, Brooklyn offers diverse career paths at a slightly lower cost than Manhattan.",
                "fun_fact": "Brooklyn was an independent city until 1898 and would be the fourth-largest city in the United States if it were still separate from New York City.",
                "hiring_stats": "The median household income in Brooklyn is approximately $67,000, with growing sectors in technology, creative industries, healthcare, and education."
              },
              "nearby_cities": ["manhattan", "buffalo"]
            },
            "buffalo": {
              "name": "Buffalo",
              "slug": "buffalo",
              "coordinates": { "lat": 42.8864, "lon": -78.8784 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 87,
              "content": {
                "intro": "Buffalo, the second-largest city in New York State, is experiencing a remarkable economic revival. With an extremely affordable cost of living and a growing tech and medical corridor, Buffalo offers excellent value for professionals seeking high quality of life.",
                "fun_fact": "Buffalo is famous for inventing chicken wings at the Anchor Bar in 1964 and is home to stunning architecture by Frank Lloyd Wright, including the Darwin Martin House.",
                "hiring_stats": "The median household income in Buffalo is approximately $42,000, with key industries including healthcare, higher education, advanced manufacturing, and a rapidly growing tech sector."
              },
              "nearby_cities": ["manhattan", "brooklyn"]
            }
          }
        },
        "ca": {
          "name": "California",
          "slug": "ca",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 10099, "rate": 0.01 },
              { "min": 10100, "max": 23942, "rate": 0.02 },
              { "min": 23943, "max": 37788, "rate": 0.04 },
              { "min": 37789, "max": 52455, "rate": 0.06 },
              { "min": 52456, "max": 66295, "rate": 0.08 },
              { "min": 66296, "max": 338639, "rate": 0.093 },
              { "min": 338640, "max": 406364, "rate": 0.103 },
              { "min": 406365, "max": 677275, "rate": 0.113 },
              { "min": 677276, "max": 999999999, "rate": 0.123 }
            ]
          },
          "cities": {
            "san-francisco": {
              "name": "San Francisco",
              "slug": "san-francisco",
              "coordinates": { "lat": 37.7749, "lon": -122.4194 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 190,
              "content": {
                "intro": "San Francisco, the tech capital of the world, is home to Silicon Valley's northern gateway. With sky-high salaries and an equally high cost of living, understanding your net pay in the Bay Area is essential for financial survival and success.",
                "fun_fact": "San Francisco's Golden Gate Bridge, completed in 1937, was the longest suspension bridge span in the world for nearly 30 years. The city is also famous for its iconic cable cars, the only mobile National Historic Landmark.",
                "hiring_stats": "The median household income in San Francisco exceeds $130,000, driven by massive employment in technology, biotech, finance, and professional services. Major employers include Salesforce, Uber, and numerous startups."
              },
              "nearby_cities": ["los-angeles", "san-diego", "san-jose", "sacramento"]
            },
            "los-angeles": {
              "name": "Los Angeles",
              "slug": "los-angeles",
              "coordinates": { "lat": 34.0522, "lon": -118.2437 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 166,
              "content": {
                "intro": "Los Angeles, the entertainment capital of the world, offers a sprawling metropolitan area with diverse industries beyond Hollywood. From aerospace to tech to international trade, LA provides vast career opportunities under year-round sunshine.",
                "fun_fact": "Los Angeles has the busiest container port complex in the Western Hemisphere, handling nearly 40% of all goods imported to the United States through the Port of LA and Port of Long Beach.",
                "hiring_stats": "The median household income in Los Angeles is approximately $75,000, with major employment sectors including entertainment, technology, healthcare, aerospace, international trade, and tourism."
              },
              "nearby_cities": ["san-francisco", "san-diego", "san-jose", "sacramento"]
            },
            "san-diego": {
              "name": "San Diego",
              "slug": "san-diego",
              "coordinates": { "lat": 32.7157, "lon": -117.1611 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 155,
              "content": {
                "intro": "San Diego, known as 'America's Finest City,' combines a thriving biotech and defense industry with beautiful coastal living. Its growing tech scene and world-class research institutions make it a magnet for skilled professionals.",
                "fun_fact": "San Diego is home to the largest naval fleet in the world — the Texas Medical Center — which employs over 106,000 people and contains 21 institutions, including 21 hospitals.",
                "hiring_stats": "The median household income in San Diego is approximately $89,000, with strong employment in biotechnology, defense, telecommunications, tourism, and healthcare."
              },
              "nearby_cities": ["los-angeles", "san-francisco", "san-jose", "sacramento"]
            },
            "san-jose": {
              "name": "San Jose",
              "slug": "san-jose",
              "coordinates": { "lat": 37.3382, "lon": -121.8863 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 195,
              "content": {
                "intro": "San Jose, the self-proclaimed Capital of Silicon Valley, is the largest city in the Bay Area and the heart of the global tech industry. With the highest median household income of any large US city, San Jose is where tech salaries are highest — but so is the cost of living.",
                "fun_fact": "San Jose has more patents per capita than any other city in the United States. The city is headquarters to Adobe, Cisco, eBay, PayPal, and Zoom, and is surrounded by the campuses of Apple, Google, and Meta.",
                "hiring_stats": "The median household income in San Jose exceeds $140,000, the highest of any large US city, with dominant employment in technology, semiconductors, software engineering, venture capital, and advanced manufacturing."
              },
              "nearby_cities": ["san-francisco", "los-angeles", "san-diego", "sacramento"]
            },
            "sacramento": {
              "name": "Sacramento",
              "slug": "sacramento",
              "coordinates": { "lat": 38.5816, "lon": -121.4944 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 118,
              "content": {
                "intro": "Sacramento, California's capital, has emerged as an affordable alternative to the Bay Area with a growing tech scene and farm-to-fork food culture. With significantly lower housing costs than San Francisco or San Jose, Sacramento offers California living at a fraction of the price.",
                "fun_fact": "Sacramento is known as the 'Farm-to-Fork Capital of America' due to its proximity to California's Central Valley, the most productive agricultural region in the world. The city's Tower Bridge is a striking golden landmark over the Sacramento River.",
                "hiring_stats": "The median household income in Sacramento is approximately $72,000, with major employment in state government, healthcare (UC Davis Medical Center, Sutter Health), technology, agriculture, and education."
              },
              "nearby_cities": ["san-francisco", "los-angeles", "san-diego", "san-jose"]
            }
          }
        },
        "tx": {
          "name": "Texas",
          "slug": "tx",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0 }
            ]
          },
          "cities": {
            "austin": {
              "name": "Austin",
              "slug": "austin",
              "coordinates": { "lat": 30.2672, "lon": -97.7431 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 119,
              "content": {
                "intro": "Austin, the capital of Texas, has exploded into one of America's hottest tech hubs. With no state income tax and a rapidly growing economy, Austin offers professionals significantly higher take-home pay compared to coastal cities.",
                "fun_fact": "Austin is the 'Live Music Capital of the World,' hosting over 250 live music venues and the famous South by Southwest (SXSW) festival. Tesla, Oracle, and Samsung all have major operations here.",
                "hiring_stats": "The median household income in Austin is approximately $85,000, with booming sectors in technology, government, higher education, healthcare, and clean energy."
              },
              "nearby_cities": ["houston", "dallas", "san-antonio", "fort-worth"]
            },
            "houston": {
              "name": "Houston",
              "slug": "houston",
              "coordinates": { "lat": 29.7604, "lon": -95.3698 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 104,
              "content": {
                "intro": "Houston, the fourth-largest city in the United States, is the energy capital of the world and home to NASA's Johnson Space Center. With no state income tax and a low cost of living, Houston offers exceptional take-home pay for professionals across many industries.",
                "fun_fact": "Houston has the largest medical center in the world — the Texas Medical Center — which employs over 106,000 people and contains 61 institutions, including 21 hospitals.",
                "hiring_stats": "The median household income in Houston is approximately $57,000, with dominant industries in energy, healthcare, aerospace, manufacturing, and international trade."
              },
              "nearby_cities": ["austin", "dallas", "san-antonio", "fort-worth"]
            },
            "dallas": {
              "name": "Dallas",
              "slug": "dallas",
              "coordinates": { "lat": 32.7767, "lon": -96.7970 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 107,
              "content": {
                "intro": "Dallas, a major financial and commercial hub in North Texas, combines big-city amenities with Texas-sized affordability. With no state income tax and a diverse economy, Dallas professionals enjoy some of the best take-home pay ratios in the country.",
                "fun_fact": "Dallas-Fort Worth has more shopping centers per capita than any other city in the United States, and the DFW International Airport is larger than the island of Manhattan.",
                "hiring_stats": "The median household income in Dallas is approximately $60,000, with thriving sectors in finance, telecommunications, technology, defense, and healthcare. AT&T, Texas Instruments, and Southwest Airlines are headquartered here."
              },
              "nearby_cities": ["austin", "houston", "fort-worth", "san-antonio"]
            },
            "san-antonio": {
              "name": "San Antonio",
              "slug": "san-antonio",
              "coordinates": { "lat": 29.4241, "lon": -98.4936 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 96,
              "content": {
                "intro": "San Antonio, the seventh-largest city in the United States, is a major military and tourism hub with deep cultural roots. With no state income tax and one of the lowest costs of living among major US cities, San Antonio offers outstanding purchasing power for professionals.",
                "fun_fact": "San Antonio is home to the Alamo, the most-visited tourist site in Texas, and five military installations including Joint Base San Antonio, the largest joint base in the Department of Defense.",
                "hiring_stats": "The median household income in San Antonio is approximately $55,000, with major employment in military and defense, healthcare, tourism, cybersecurity, biosciences, and financial services."
              },
              "nearby_cities": ["austin", "houston", "dallas", "fort-worth"]
            },
            "fort-worth": {
              "name": "Fort Worth",
              "slug": "fort-worth",
              "coordinates": { "lat": 32.7555, "lon": -97.3308 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 98,
              "content": {
                "intro": "Fort Worth, the 13th-largest city in the US, blends Western heritage with modern aerospace and defense industries. With no state income tax and an affordable cost of living, Fort Worth offers excellent value — especially for professionals in aviation and manufacturing.",
                "fun_fact": "Fort Worth's Stockyards National Historic District hosts the world's only twice-daily cattle drive, and the city is home to Lockheed Martin's F-35 fighter jet assembly plant, the largest defense program in history.",
                "hiring_stats": "The median household income in Fort Worth is approximately $62,000, with major employment in aerospace (Lockheed Martin, Bell), defense, healthcare, logistics, and oil and gas."
              },
              "nearby_cities": ["dallas", "austin", "houston", "san-antonio"]
            }
          }
        },
        "fl": {
          "name": "Florida",
          "slug": "fl",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0 }
            ]
          },
          "cities": {
            "miami": {
              "name": "Miami",
              "slug": "miami",
              "coordinates": { "lat": 25.7617, "lon": -80.1918 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 133,
              "content": {
                "intro": "Miami, the gateway to Latin America, is a vibrant international city with a booming finance and tech scene. With no state income tax and a subtropical climate, Miami has become a top destination for remote workers and entrepreneurs seeking to maximize their take-home pay.",
                "fun_fact": "Miami is the only major US city founded by a woman — Julia Tuttle. Today it's the cruise capital of the world, with PortMiami handling over 7 million cruise passengers annually.",
                "hiring_stats": "The median household income in Miami is approximately $52,000, with growing sectors in international finance, real estate, technology, tourism, healthcare, and trade."
              },
              "nearby_cities": ["orlando", "tampa", "jacksonville"]
            },
            "orlando": {
              "name": "Orlando",
              "slug": "orlando",
              "coordinates": { "lat": 28.5383, "lon": -81.3792 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 103,
              "content": {
                "intro": "Orlando, famous for its world-class theme parks, has quietly built a diverse economy spanning simulation technology, aerospace, and healthcare. With no state income tax and an affordable cost of living, Orlando offers strong financial value for professionals.",
                "fun_fact": "Orlando attracts over 75 million visitors annually, making it the most-visited city in the United States. Beyond tourism, it's home to the nation's largest simulation and training technology cluster.",
                "hiring_stats": "The median household income in Orlando is approximately $55,000, with key industries in tourism, simulation technology, aerospace, healthcare, and a growing tech startup ecosystem."
              },
              "nearby_cities": ["miami", "tampa", "jacksonville"]
            },
            "tampa": {
              "name": "Tampa",
              "slug": "tampa",
              "coordinates": { "lat": 27.9506, "lon": -82.4572 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 101,
              "content": {
                "intro": "Tampa, located on Florida's Gulf Coast, combines a thriving financial services sector with an affordable waterfront lifestyle. With no state income tax and a cost of living near the national average, Tampa delivers excellent purchasing power for working professionals.",
                "fun_fact": "Tampa is home to the famous Gasparilla Pirate Festival, one of the largest parades in the US, and the city's port is the largest in Florida by tonnage, driving significant economic activity.",
                "hiring_stats": "The median household income in Tampa is approximately $58,000, with strong employment in financial services, healthcare, defense (MacDill Air Force Base), technology, and insurance."
              },
              "nearby_cities": ["miami", "orlando", "jacksonville"]
            },
            "jacksonville": {
              "name": "Jacksonville",
              "slug": "jacksonville",
              "coordinates": { "lat": 30.3322, "lon": -81.6557 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 96,
              "content": {
                "intro": "Jacksonville, the largest city by area in the contiguous United States, is a major logistics, financial services, and military hub. With no state income tax and one of the most affordable costs of living among Florida's major cities, Jacksonville offers exceptional take-home pay.",
                "fun_fact": "Jacksonville is the largest city by land area in the contiguous US at 875 square miles and is home to Naval Station Mayport, the third-largest naval facility in the country. The city also has 22 miles of beaches.",
                "hiring_stats": "The median household income in Jacksonville is approximately $58,000, with major employment in logistics, financial services (FIS, Fidelity), military and defense, healthcare, and insurance."
              },
              "nearby_cities": ["miami", "orlando", "tampa"]
            }
          }
        },
        "il": {
          "name": "Illinois",
          "slug": "il",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0495 }
            ]
          },
          "cities": {
            "chicago": {
              "name": "Chicago",
              "slug": "chicago",
              "coordinates": { "lat": 41.8781, "lon": -87.6298 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 117,
              "content": {
                "intro": "Chicago, the birthplace of American democracy, is the largest city in Pennsylvania and a major East Coast economic hub. With a lower cost of living than nearby New York and strong job growth, Philly offers solid financial value — though its local wage tax is one of the highest in the nation.",
                "fun_fact": "Philadelphia was the first US city to have a zoo (1874), a hospital (1751), and a stock exchange (1790). Today its 'Eds and Meds' economy — universities and hospitals — is the backbone of the local workforce.",
                "hiring_stats": "The median household income in Philadelphia is approximately $52,000, with dominant sectors in healthcare, higher education, pharmaceuticals, financial services, and a growing tech scene."
              },
              "nearby_cities": []
            }
          }
        },
        "pa": {
          "name": "Pennsylvania",
          "slug": "pa",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0307 }
            ]
          },
          "cities": {
            "philadelphia": {
              "name": "Philadelphia",
              "slug": "philadelphia",
              "coordinates": { "lat": 39.9526, "lon": -75.1652 },
              "local_tax_rate": 0.03807,
              "cost_of_living_index": 114,
              "content": {
                "intro": "Philadelphia, the birthplace of American democracy, is the largest city in Pennsylvania and a major East Coast economic hub. With a lower cost of living than nearby New York and strong job growth, Philly offers solid financial value — though its local wage tax is one of the highest in the nation.",
                "fun_fact": "Philadelphia was the first US city to have a zoo (1874), a hospital (1751), and a stock exchange (1790). Today its 'Eds and Meds' economy — universities and hospitals — is the backbone of the local workforce.",
                "hiring_stats": "The median household income in Philadelphia is approximately $52,000, with dominant sectors in healthcare, higher education, pharmaceuticals, financial services, and a growing tech scene."
              },
              "nearby_cities": ["pittsburgh"]
            },
            "pittsburgh": {
              "name": "Pittsburgh",
              "slug": "pittsburgh",
              "coordinates": { "lat": 40.4406, "lon": -79.9959 },
              "local_tax_rate": 0.03,
              "cost_of_living_index": 96,
              "content": {
                "intro": "Pittsburgh, Michigan's second-largest city, has reinvented itself from an oil capital into a remote work destination with its famous Tulsa Remote program. With an extremely low cost of living and growing tech scene, Tulsa offers outstanding financial value.",
                "fun_fact": "Tulsa's Gathering Place, a 66-acre public park, was named the best new attraction in the US by USA Today. The city's Tulsa Remote program pays remote workers $10,000 to relocate, attracting tech talent from across the country.",
                "hiring_stats": "The median household income in Tulsa is approximately $48,000, with major employment in energy, aerospace, healthcare, finance, and a rapidly growing remote work and technology sector."
              },
              "nearby_cities": ["detroit", "ann-arbor"]
            }
          }
        },
        "ma": {
          "name": "Massachusetts",
          "slug": "ma",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.05 }
            ]
          },
          "cities": {
            "boston": {
              "name": "Boston",
              "slug": "boston",
              "coordinates": { "lat": 42.3601, "lon": -71.0589 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 162,
              "content": {
                "intro": "Boston, the capital of Massachusetts, is a world-renowned center for education, healthcare, and biotechnology. Home to Harvard and MIT, the city attracts top talent globally — but its high cost of living makes understanding your take-home pay critical.",
                "fun_fact": "Boston's 'Innovation District' in the Seaport has become one of the densest startup ecosystems in the world, and the city's hospitals — including Mass General and Brigham and Women's — are consistently ranked among the best globally.",
                "hiring_stats": "The median household income in Boston is approximately $81,000, with powerhouse industries in biotechnology, healthcare, higher education, financial services, and technology."
              },
              "nearby_cities": ["cambridge"]
            },
            "cambridge": {
              "name": "Cambridge",
              "slug": "cambridge",
              "coordinates": { "lat": 42.3736, "lon": -71.1097 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 170,
              "content": {
                "intro": "Cambridge, home to both Harvard University and MIT, is one of the most intellectually concentrated cities on Earth. Its Kendall Square neighborhood is called 'the most innovative square mile on the planet,' making it a magnet for biotech and tech professionals.",
                "fun_fact": "Kendall Square in Cambridge houses more biotech companies per square foot than anywhere else in the world. Google, Microsoft, and hundreds of pharmaceutical companies have major offices here.",
                "hiring_stats": "The median household income in Cambridge is approximately $108,000, with dominant employment in biotechnology, pharmaceuticals, technology, academic research, and venture capital."
              },
              "nearby_cities": ["boston"]
            }
          }
        },
        "wa": {
          "name": "Washington",
          "slug": "wa",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0 }
            ]
          },
          "cities": {
            "seattle": {
              "name": "Seattle",
              "slug": "seattle",
              "coordinates": { "lat": 47.6062, "lon": -122.3321 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 172,
              "content": {
                "intro": "Seattle, the Emerald City, is a global tech powerhouse and home to Amazon, Microsoft, and Boeing. With no state income tax, Seattle professionals keep significantly more of their paycheck compared to peers in California or New York — a major financial advantage despite the high cost of living.",
                "fun_fact": "Seattle's Pike Place Market, opened in 1907, is one of the oldest continuously operated public farmers' markets in the US. The city also gets less annual rainfall than New York, Atlanta, or Houston — despite its rainy reputation.",
                "hiring_stats": "The median household income in Seattle exceeds $110,000, driven by massive employment in technology, aerospace, cloud computing, e-commerce, and healthcare."
              },
              "nearby_cities": []
            }
          }
        },
        "co": {
          "name": "Colorado",
          "slug": "co",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.044 }
            ]
          },
          "cities": {
            "denver": {
              "name": "Denver",
              "slug": "denver",
              "coordinates": { "lat": 39.7392, "lon": -104.9903 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 128,
              "content": {
                "intro": "Denver, the Mile High City, has emerged as one of America's fastest-growing tech and outdoor lifestyle hubs. With a moderate state tax rate and a cost of living below coastal cities, Denver offers an attractive balance of career opportunity and quality of life.",
                "fun_fact": "Denver has 300 days of sunshine per year — more than San Diego or Miami. The city's craft beer scene is legendary, with over 70 breweries within city limits, more per capita than any other US city.",
                "hiring_stats": "The median household income in Denver is approximately $78,000, with strong employment in technology, aerospace, energy, healthcare, outdoor recreation industries, and federal government."
              },
              "nearby_cities": []
            }
          }
        },
        "ga": {
          "name": "Georgia",
          "slug": "ga",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 750, "rate": 0.01 },
              { "min": 751, "max": 2250, "rate": 0.02 },
              { "min": 2251, "max": 3750, "rate": 0.03 },
              { "min": 3751, "max": 5250, "rate": 0.04 },
              { "min": 5251, "max": 7000, "rate": 0.05 },
              { "min": 7001, "max": 999999999, "rate": 0.055 }
            ]
          },
          "cities": {
            "atlanta": {
              "name": "Atlanta",
              "slug": "atlanta",
              "coordinates": { "lat": 33.7490, "lon": -84.3880 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 112,
              "content": {
                "intro": "Atlanta, the capital of Georgia and the economic engine of the Southeast, is a major hub for Fortune 500 companies, film production, and technology. With a moderate cost of living and strong job market, Atlanta offers excellent career value for professionals across many fields.",
                "fun_fact": "Atlanta is home to the world's busiest airport (Hartsfield-Jackson), the headquarters of Coca-Cola, Delta Air Lines, UPS, and Home Depot, and has become the 'Hollywood of the South' with more film and TV production than Los Angeles.",
                "hiring_stats": "The median household income in Atlanta is approximately $69,000, with major employment in logistics, film production, technology, financial services, healthcare, and corporate headquarters."
              },
              "nearby_cities": []
            }
          }
        },
        "az": {
          "name": "Arizona",
          "slug": "az",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.025 }
            ]
          },
          "cities": {
            "phoenix": {
              "name": "Phoenix",
              "slug": "phoenix",
              "coordinates": { "lat": 33.4484, "lon": -112.0740 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 103,
              "content": {
                "intro": "Phoenix, the fifth-largest city in the United States, offers a booming economy with one of the lowest tax burdens in the country. Arizona's flat 2.5% income tax rate combined with an affordable cost of living makes Phoenix a top destination for professionals seeking maximum take-home pay.",
                "fun_fact": "Phoenix is the hottest city in the United States, with an average of 299 sunny days per year. It's also one of the fastest-growing cities in the nation, with major semiconductor manufacturing from TSMC and Intel driving a tech boom.",
                "hiring_stats": "The median household income in Phoenix is approximately $65,000, with rapidly growing sectors in semiconductor manufacturing, aerospace, financial services, healthcare, and technology."
              },
              "nearby_cities": ["scottsdale", "tucson", "mesa"]
            },
            "scottsdale": {
              "name": "Scottsdale",
              "slug": "scottsdale",
              "coordinates": { "lat": 33.4942, "lon": -111.9261 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 121,
              "content": {
                "intro": "Scottsdale, known for its luxury resorts and vibrant arts scene, has become a thriving business hub in the Phoenix metropolitan area. With Arizona's low flat tax rate and a high quality of life, Scottsdale attracts executives, entrepreneurs, and tech professionals from across the country.",
                "fun_fact": "Scottsdale's Old Town district has been named one of the top 25 arts destinations in the world, and the city hosts the largest horse show in the world — the Scottsdale Arabian Horse Show.",
                "hiring_stats": "The median household income in Scottsdale exceeds $98,000, with strong employment in financial services, tourism, healthcare, technology startups, and luxury hospitality."
              },
              "nearby_cities": ["phoenix", "tucson", "mesa"]
            },
            "tucson": {
              "name": "Tucson",
              "slug": "tucson",
              "coordinates": { "lat": 32.2226, "lon": -110.9747 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 95,
              "content": {
                "intro": "Tucson, Arizona's second-largest city and home to the University of Arizona, offers a unique blend of Sonoran Desert beauty and academic excellence. With Arizona's low flat tax rate and an extremely affordable cost of living, Tucson provides outstanding value for professionals in education, defense, and technology.",
                "fun_fact": "Tucson was designated a UNESCO City of Gastronomy — the first in the United States — recognizing its 4,000-year history of food cultivation. The city is also home to the Pima Air & Space Museum, one of the largest aviation museums in the world.",
                "hiring_stats": "The median household income in Tucson is approximately $48,000, with major employment in higher education (University of Arizona), defense (Davis-Monthan AFB, Raytheon), healthcare, optics, and aerospace."
              },
              "nearby_cities": ["phoenix", "scottsdale", "mesa"]
            },
            "mesa": {
              "name": "Mesa",
              "slug": "mesa",
              "coordinates": { "lat": 33.4152, "lon": -111.8315 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 99,
              "content": {
                "intro": "Mesa, the third-largest city in Arizona, is a rapidly growing suburb of Phoenix with a strong aerospace and technology presence. With Arizona's low flat tax and affordable housing, Mesa offers families and professionals excellent value in the heart of the Phoenix metro area.",
                "fun_fact": "Mesa is larger in population than cities like Atlanta, Miami, and Minneapolis. The city is home to the Boeing AH-64 Apache helicopter production facility and the Chicago Cubs' spring training facility at Sloan Park.",
                "hiring_stats": "The median household income in Mesa is approximately $58,000, with major employment in aerospace (Boeing), healthcare, education, technology, and manufacturing."
              },
              "nearby_cities": ["phoenix", "scottsdale", "tucson"]
            }
          }
        },
        "nc": {
          "name": "North Carolina",
          "slug": "nc",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0475 }
            ]
          },
          "cities": {
            "charlotte": {
              "name": "Charlotte",
              "slug": "charlotte",
              "coordinates": { "lat": 35.2271, "lon": -80.8431 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 105,
              "content": {
                "intro": "Charlotte, the second-largest banking center in the United States after New York, is a powerhouse of finance and energy. With a moderate state tax rate and a cost of living near the national average, Charlotte offers exceptional value for professionals in financial services and beyond.",
                "fun_fact": "Charlotte is home to Bank of America and Truist Financial headquarters, and the city's NASCAR Hall of Fame reflects its deep roots in motorsport culture. The Charlotte metro area has been one of the fastest-growing in the US for over a decade.",
                "hiring_stats": "The median household income in Charlotte is approximately $68,000, with dominant industries in banking, financial services, energy, technology, healthcare, and motorsport engineering."
              },
              "nearby_cities": ["raleigh"]
            },
            "raleigh": {
              "name": "Raleigh",
              "slug": "raleigh",
              "coordinates": { "lat": 35.7796, "lon": -78.6382 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 102,
              "content": {
                "intro": "Raleigh, the capital of North Carolina and anchor of the Research Triangle, is one of America's premier technology and research hubs. With three major universities nearby and a cost of living near the national average, Raleigh consistently ranks among the best places to live and work in the US.",
                "fun_fact": "The Research Triangle Park (RTP) between Raleigh, Durham, and Chapel Hill is the largest research park in the United States, housing over 300 companies including IBM, Cisco, and numerous biotech firms.",
                "hiring_stats": "The median household income in Raleigh is approximately $74,000, with thriving sectors in technology, biotechnology, pharmaceutical research, higher education, and government."
              },
              "nearby_cities": ["charlotte"]
            }
          }
        },
        "tn": {
          "name": "Tennessee",
          "slug": "tn",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0 }
            ]
          },
          "cities": {
            "nashville": {
              "name": "Nashville",
              "slug": "nashville",
              "coordinates": { "lat": 36.1627, "lon": -86.7816 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 107,
              "content": {
                "intro": "Nashville, the capital of Tennessee and Music City USA, has evolved far beyond its country music roots into a booming tech, healthcare, and entertainment hub. With no state income tax and a moderate cost of living, Nashville professionals enjoy outstanding take-home pay compared to coastal cities.",
                "fun_fact": "Nashville is the healthcare capital of the United States, with over 500 healthcare companies headquartered in the metro area, including HCA Healthcare, the largest private hospital operator in the world.",
                "hiring_stats": "The median household income in Nashville is approximately $65,000, with growing sectors in healthcare, music and entertainment, technology, hospitality, higher education, and corporate headquarters."
              },
              "nearby_cities": ["memphis", "chattanooga"]
            },
            "memphis": {
              "name": "Memphis",
              "slug": "memphis",
              "coordinates": { "lat": 35.1495, "lon": -90.0490 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 87,
              "content": {
                "intro": "Memphis, home of the blues and birthplace of rock and roll, is a major logistics and distribution hub on the Mississippi River. With no state income tax and one of the lowest costs of living among major US cities, Memphis offers exceptional purchasing power for working professionals.",
                "fun_fact": "Memphis is home to the largest naval fleet in the world — the Texas Medical Center — which employs over 106,000 people and contains 21 institutions, including 21 hospitals.",
                "hiring_stats": "The median household income in Memphis is approximately $44,000, with major employment in logistics, healthcare, manufacturing, agriculture, and the music and hospitality industries."
              },
              "nearby_cities": ["nashville", "chattanooga"]
            },
            "chattanooga": {
              "name": "Chattanooga",
              "slug": "chattanooga",
              "coordinates": { "lat": 35.0456, "lon": -85.3097 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 89,
              "content": {
                "intro": "Chattanooga, nestled in the Tennessee Valley between the Appalachian Mountains, has reinvented itself as a tech-forward city with the fastest internet in the Western Hemisphere. With no state income tax and an extremely affordable cost of living, Chattanooga is a rising star for remote workers and startups.",
                "fun_fact": "Chattanooga was the first city in the United States to offer citywide 10-gigabit-per-second internet service through its municipal fiber network, earning it the nickname 'Gig City.'",
                "hiring_stats": "The median household income in Chattanooga is approximately $50,000, with growing sectors in technology, advanced manufacturing, tourism, healthcare, and the outdoor recreation industry."
              },
              "nearby_cities": ["nashville", "memphis"]
            }
          }
        },
        "nv": {
          "name": "Nevada",
          "slug": "nv",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0 }
            ]
          },
          "cities": {
            "las-vegas": {
              "name": "Las Vegas",
              "slug": "las-vegas",
              "coordinates": { "lat": 36.1699, "lon": -115.1398 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 104,
              "content": {
                "intro": "Las Vegas, the Entertainment Capital of the World, has diversified well beyond casinos into technology, healthcare, and professional sports. With no state income tax and a cost of living near the national average, Las Vegas offers professionals significantly more take-home pay than comparable cities in taxed states.",
                "fun_fact": "Las Vegas is now home to three major professional sports teams — the Raiders (NFL), Golden Knights (NHL), and Aces (WNBA) — and the Las Vegas Strip generates more revenue than the entire GDP of some small countries.",
                "hiring_stats": "The median household income in Las Vegas is approximately $62,000, with major employment in hospitality, entertainment, healthcare, technology, construction, and a rapidly growing sports industry."
              },
              "nearby_cities": ["henderson", "reno"]
            },
            "henderson": {
              "name": "Henderson",
              "slug": "henderson",
              "coordinates": { "lat": 36.0395, "lon": -114.9817 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 108,
              "content": {
                "intro": "Henderson, Nevada's second-largest city, is consistently ranked among the safest and most livable cities in America. Located just minutes from the Las Vegas Strip, Henderson offers suburban tranquility with big-city amenities and zero state income tax.",
                "fun_fact": "Henderson has been named one of the 'Best Places to Live' by multiple publications and is home to several master-planned communities, world-class golf courses, and the Henderson Executive Airport.",
                "hiring_stats": "The median household income in Henderson is approximately $72,000, with employment in healthcare, retail, professional services, education, and proximity to Las Vegas entertainment employers."
              },
              "nearby_cities": ["las-vegas", "reno"]
            },
            "reno": {
              "name": "Reno",
              "slug": "reno",
              "coordinates": { "lat": 39.5296, "lon": -119.8138 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 107,
              "content": {
                "intro": "Reno, the Biggest Little City in the World, has transformed into a major tech and logistics hub. With Tesla's Gigafactory nearby, no state income tax, and proximity to Lake Tahoe, Reno attracts professionals seeking an outdoor lifestyle with strong career opportunities.",
                "fun_fact": "Tesla's Gigafactory Nevada, located just east of Reno, is one of the largest buildings in the world by footprint and has made the Reno-Sparks area a major player in electric vehicle manufacturing and battery technology.",
                "hiring_stats": "The median household income in Reno is approximately $60,000, with growing sectors in advanced manufacturing, logistics, technology, gaming, tourism, and renewable energy."
              },
              "nearby_cities": ["las-vegas", "henderson"]
            }
          }
        },
        "or": {
          "name": "Oregon",
          "slug": "or",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 3750, "rate": 0.0475 },
              { "min": 3751, "max": 9450, "rate": 0.0675 },
              { "min": 9451, "max": 125000, "rate": 0.0875 },
              { "min": 125001, "max": 999999999, "rate": 0.099 }
            ]
          },
          "cities": {
            "portland": {
              "name": "Portland",
              "slug": "portland",
              "coordinates": { "lat": 45.5152, "lon": -122.6784 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 130,
              "content": {
                "intro": "Portland, Oregon's largest city, is a creative and tech-forward metropolis known for its sustainability ethos and vibrant food scene. While Oregon has one of the highest state income tax rates, Portland has no sales tax — making your salary calculation unique compared to other major cities.",
                "fun_fact": "Portland has more breweries per capita than any other city in the world and is home to the largest independent bookstore in the world — Powell's City of Books, which occupies an entire city block.",
                "hiring_stats": "The median household income in Portland is approximately $78,000, with strong employment in technology (Intel, Nike), creative industries, healthcare, sustainability, and craft manufacturing."
              },
              "nearby_cities": ["salem", "eugene"]
            },
            "salem": {
              "name": "Salem",
              "slug": "salem",
              "coordinates": { "lat": 44.9429, "lon": -123.0351 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 108,
              "content": {
                "intro": "Salem, the capital of Oregon, offers a more affordable alternative to Portland while maintaining access to the state's natural beauty. As the center of state government, Salem provides stable employment and a family-friendly lifestyle in the heart of the Willamette Valley.",
                "fun_fact": "Salem sits in the heart of Oregon's wine country, surrounded by over 700 wineries in the Willamette Valley, which produces some of the world's finest Pinot Noir.",
                "hiring_stats": "The median household income in Salem is approximately $55,000, with major employment in state government, agriculture, food processing, healthcare, and education."
              },
              "nearby_cities": ["portland", "eugene"]
            },
            "eugene": {
              "name": "Eugene",
              "slug": "eugene",
              "coordinates": { "lat": 44.0521, "lon": -123.0868 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 112,
              "content": {
                "intro": "Eugene, home to the University of Oregon, is a vibrant college town known for its running culture and environmental consciousness. Nike was founded here, and the city continues to attract outdoor enthusiasts and creative professionals.",
                "fun_fact": "Eugene is known as 'Track Town USA' and was the birthplace of Nike — Phil Knight and Bill Bowerman started the company here. The city hosted the 2022 World Athletics Championships.",
                "hiring_stats": "The median household income in Eugene is approximately $52,000, with employment in higher education, healthcare, technology, outdoor recreation, and sustainable industries."
              },
              "nearby_cities": ["portland", "salem"]
            }
          }
        },
        "ut": {
          "name": "Utah",
          "slug": "ut",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0465 }
            ]
          },
          "cities": {
            "salt-lake-city": {
              "name": "Salt Lake City",
              "slug": "salt-lake-city",
              "coordinates": { "lat": 40.7608, "lon": -111.8910 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 110,
              "content": {
                "intro": "Salt Lake City, the capital of Utah, has emerged as one of America's fastest-growing cities, attracting tech workers and outdoor enthusiasts from more expensive West Coast cities. With a moderate cost of living and access to world-class outdoor recreation, SLC offers an exceptional work-life balance for professionals.",
                "fun_fact": "Salt Lake City's 'Silicon Slopes' tech corridor is home to over 6,500 tech companies, and the city is within 45 minutes of 11 world-class ski resorts, making it a paradise for outdoor enthusiasts.",
                "hiring_stats": "The median household income in Salt Lake City is approximately $65,000, with booming sectors in technology, outdoor recreation, healthcare, financial services, and aerospace."
              },
              "nearby_cities": ["provo"]
            },
            "provo": {
              "name": "Provo",
              "slug": "provo",
              "coordinates": { "lat": 40.2338, "lon": -111.6585 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 104,
              "content": {
                "intro": "Provo, home to Brigham Young University, is a thriving tech and startup hub in the heart of Utah's Silicon Slopes. With an extremely affordable cost of living and a young, educated workforce, Provo has become one of the best cities for entrepreneurs in America.",
                "fun_fact": "Provo has been ranked the #1 city for startups in the US multiple times, with successful companies like Qualtrics, Vivint, and Ancestry.com originating from the area.",
                "hiring_stats": "The median household income in Provo is approximately $55,000, with strong employment in technology startups, higher education, software development, and outdoor recreation industries."
              },
              "nearby_cities": ["salt-lake-city"]
            }
          }
        },
        "mn": {
          "name": "Minnesota",
          "slug": "mn",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 30070, "rate": 0.0535 },
              { "min": 30071, "max": 98760, "rate": 0.068 },
              { "min": 98761, "max": 183340, "rate": 0.0785 },
              { "min": 183341, "max": 999999999, "rate": 0.0985 }
            ]
          },
          "cities": {
            "minneapolis": {
              "name": "Minneapolis",
              "slug": "minneapolis",
              "coordinates": { "lat": 44.9778, "lon": -93.2650 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 112,
              "content": {
                "intro": "Minneapolis, the larger half of the Twin Cities, is a Fortune 500 powerhouse with more corporate headquarters per capita than any other US city. While Minnesota has one of the higher state tax rates, the city's strong salaries and moderate cost of living help offset the tax burden.",
                "fun_fact": "Minneapolis has more Fortune 500 companies per capita than any other US city, including Target, UnitedHealth Group, US Bancorp, and General Mills. The city also has more theater seats per capita than any city outside New York.",
                "hiring_stats": "The median household income in Minneapolis is approximately $70,000, with major employment in corporate headquarters, healthcare, financial services, food production, retail, and technology."
              },
              "nearby_cities": ["saint-paul"]
            },
            "saint-paul": {
              "name": "Saint Paul",
              "slug": "saint-paul",
              "coordinates": { "lat": 44.9537, "lon": -93.0900 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 105,
              "content": {
                "intro": "Saint Paul, Minnesota's capital and the quieter twin of Minneapolis, offers a more affordable urban experience with excellent schools and a rich cultural heritage. As the seat of state government, Saint Paul provides stable employment and a high quality of life.",
                "fun_fact": "Saint Paul's Winter Carnival, held annually since 1886, is one of the oldest and largest winter festivals in the United States, featuring ice palaces, parades, and outdoor activities.",
                "hiring_stats": "The median household income in Saint Paul is approximately $60,000, with strong employment in state government, healthcare, education, insurance, and manufacturing."
              },
              "nearby_cities": ["minneapolis"]
            }
          }
        },
        "mi": {
          "name": "Michigan",
          "slug": "mi",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0425 }
            ]
          },
          "cities": {
            "detroit": {
              "name": "Detroit",
              "slug": "detroit",
              "coordinates": { "lat": 42.3314, "lon": -83.0458 },
              "local_tax_rate": 0.024,
              "cost_of_living_index": 89,
              "content": {
                "intro": "Detroit, the Motor City, is experiencing a remarkable renaissance driven by automotive innovation, technology, and urban revitalization. With one of the lowest costs of living among major US cities and a growing job market, Detroit offers exceptional value — though its local income tax adds a unique consideration to your salary calculation.",
                "fun_fact": "Detroit is the birthplace of the American automotive industry and Motown Records. Today, the city is at the forefront of electric and autonomous vehicle development, with GM, Ford, and numerous startups driving innovation.",
                "hiring_stats": "The median household income in Detroit is approximately $36,000, with major employment in automotive manufacturing, technology, healthcare, logistics, and a rapidly growing startup ecosystem."
              },
              "nearby_cities": ["ann-arbor", "grand-rapids"]
            },
            "ann-arbor": {
              "name": "Ann Arbor",
              "slug": "ann-arbor",
              "coordinates": { "lat": 42.2808, "lon": -83.7430 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 118,
              "content": {
                "intro": "Ann Arbor, home to the University of Michigan, is a vibrant college town with a thriving tech and research economy. Known for its excellent schools, cultural amenities, and proximity to Detroit, Ann Arbor attracts highly educated professionals seeking a balanced lifestyle.",
                "fun_fact": "Ann Arbor is home to the University of Michigan, one of the top public universities in the world, and the city's tech sector has earned it the nickname 'Tree Town Tech' for its growing startup ecosystem.",
                "hiring_stats": "The median household income in Ann Arbor is approximately $68,000, with strong employment in higher education, healthcare, technology, automotive research, and life sciences."
              },
              "nearby_cities": ["detroit", "grand-rapids"]
            },
            "grand-rapids": {
              "name": "Grand Rapids",
              "slug": "grand-rapids",
              "coordinates": { "lat": 42.9634, "lon": -85.6681 },
              "local_tax_rate": 0.015,
              "cost_of_living_index": 92,
              "content": {
                "intro": "Grand Rapids, Michigan's second-largest city, is a thriving manufacturing and healthcare hub with an award-winning craft beer scene. With an extremely affordable cost of living and strong job growth, Grand Rapids consistently ranks among the best mid-size cities in America.",
                "fun_fact": "Grand Rapids was named 'Beer City USA' multiple times and hosts ArtPrize, the world's largest open art competition. The city's craft beer scene is legendary, with over 100 breweries within city limits.",
                "hiring_stats": "The median household income in Grand Rapids is approximately $52,000, with major employment in manufacturing, healthcare, food processing, technology, and the craft beverage industry."
              },
              "nearby_cities": ["detroit", "ann-arbor"]
            }
          }
        },
        "oh": {
          "name": "Ohio",
          "slug": "oh",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 26050, "rate": 0.0 },
              { "min": 26051, "max": 100000, "rate": 0.02765 },
              { "min": 100001, "max": 999999999, "rate": 0.035 }
            ]
          },
          "cities": {
            "columbus": {
              "name": "Columbus",
              "slug": "columbus",
              "coordinates": { "lat": 39.9612, "lon": -82.9988 },
              "local_tax_rate": 0.025,
              "cost_of_living_index": 96,
              "content": {
                "intro": "Columbus, Ohio's capital and largest city, is a rising tech and logistics hub anchored by Ohio State University. With an affordable cost of living and a diverse economy, Columbus has quietly become one of the fastest-growing cities in the Midwest.",
                "fun_fact": "Columbus is the test market capital of America — companies from Wendy's to White Castle to Bath & Body Works were founded here, and major brands test new products in Columbus before national rollouts.",
                "hiring_stats": "The median household income in Columbus is approximately $58,000, with strong employment in technology, insurance, banking, healthcare, logistics, and higher education."
              },
              "nearby_cities": ["cincinnati", "cleveland"]
            },
            "cincinnati": {
              "name": "Cincinnati",
              "slug": "cincinnati",
              "coordinates": { "lat": 39.1031, "lon": -84.5120 },
              "local_tax_rate": 0.021,
              "cost_of_living_index": 93,
              "content": {
                "intro": "Cincinnati, the Queen City, is a major corporate headquarters hub straddling the Ohio-Kentucky border. Home to Procter & Gamble, Kroger, and Fifth Third Bank, Cincinnati offers big-city career opportunities with a remarkably affordable cost of living.",
                "fun_fact": "Cincinnati is home to the first professional baseball team (the Red Stockings, 1869) and Procter & Gamble, which invented modern brand management. The city's chili — served over spaghetti — is a beloved local institution.",
                "hiring_stats": "The median household income in Cincinnati is approximately $48,000, with major employment in consumer goods, financial services, healthcare, manufacturing, and logistics."
              },
              "nearby_cities": ["columbus", "cleveland"]
            },
            "cleveland": {
              "name": "Cleveland",
              "slug": "cleveland",
              "coordinates": { "lat": 41.4993, "lon": -81.6944 },
              "local_tax_rate": 0.025,
              "cost_of_living_index": 88,
              "content": {
                "intro": "Cleveland, situated on the shores of Lake Erie, is a healthcare and manufacturing powerhouse undergoing significant urban renewal. With the Cleveland Clinic as its anchor institution and one of the lowest costs of living among major US cities, Cleveland offers outstanding value for healthcare and tech professionals.",
                "fun_fact": "The Cleveland Clinic is consistently ranked among the top hospitals in the world, and the city's Rock and Roll Hall of Fame draws over 500,000 visitors annually. Cleveland also has one of the largest performing arts centers in the US.",
                "hiring_stats": "The median household income in Cleveland is approximately $35,000, with dominant industries in healthcare, manufacturing, financial services, biomedical research, and a growing tech sector."
              },
              "nearby_cities": ["columbus", "cincinnati"]
            }
          }
        },
        "in": {
          "name": "Indiana",
          "slug": "in",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.0305 }
            ]
          },
          "cities": {
            "indianapolis": {
              "name": "Indianapolis",
              "slug": "indianapolis",
              "coordinates": { "lat": 39.7684, "lon": -86.1581 },
              "local_tax_rate": 0.0202,
              "cost_of_living_index": 93,
              "content": {
                "intro": "Indianapolis, the capital of Indiana and the racing capital of the world, is a major logistics, pharmaceutical, and sports hub. With one of the lowest combined tax burdens and costs of living among major US cities, Indianapolis offers exceptional take-home pay for professionals.",
                "fun_fact": "Indianapolis hosts the Indianapolis 500, the largest single-day sporting event in the world, attracting over 300,000 spectators. The city is also the amateur sports capital of the US, hosting more than 400 sporting events annually.",
                "hiring_stats": "The median household income in Indianapolis is approximately $52,000, with major employment in pharmaceuticals (Eli Lilly), motorsports, logistics, healthcare, insurance, and technology."
              },
              "nearby_cities": []
            }
          }
        },
        "wi": {
          "name": "Wisconsin",
          "slug": "wi",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 14320, "rate": 0.0354 },
              { "min": 14321, "max": 28640, "rate": 0.0465 },
              { "min": 28641, "max": 315310, "rate": 0.053 },
              { "min": 315311, "max": 999999999, "rate": 0.0765 }
            ]
          },
          "cities": {
            "milwaukee": {
              "name": "Milwaukee",
              "slug": "milwaukee",
              "coordinates": { "lat": 43.0389, "lon": -87.9065 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 92,
              "content": {
                "intro": "Milwaukee, Wisconsin's largest city, is a manufacturing and brewing powerhouse on the shores of Lake Michigan. With an extremely affordable cost of living and a revitalized downtown, Milwaukee offers strong career opportunities in a city that punches well above its weight culturally.",
                "fun_fact": "Milwaukee is home to the world's tallest state capitol building in the United States at 450 feet, built by Huey Long in 1932. The city's petrochemical corridor along the Mississippi is one of the largest in the world.",
                "hiring_stats": "The median household income in Milwaukee is approximately $46,000, with major employment in manufacturing, healthcare, financial services, brewing, water technology, and energy."
              },
              "nearby_cities": ["madison"]
            },
            "madison": {
              "name": "Madison",
              "slug": "madison",
              "coordinates": { "lat": 43.0731, "lon": -89.4012 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 108,
              "content": {
                "intro": "Madison, Wisconsin's capital and home to the University of Wisconsin, is consistently ranked among the best places to live in America. With a highly educated workforce, thriving tech scene, and beautiful isthmus setting between two lakes, Madison offers an exceptional quality of life.",
                "fun_fact": "Madison is built on an isthmus between Lake Mendota and Lake Monona, giving it one of the most unique geographic settings of any US capital. The city's Dane County Farmers' Market is the largest producer-only farmers' market in the country.",
                "hiring_stats": "The median household income in Madison is approximately $72,000, with strong employment in state government, higher education, healthcare, biotechnology, insurance, and technology startups."
              },
              "nearby_cities": ["milwaukee"]
            }
          }
        },
        "la": {
          "name": "Louisiana",
          "slug": "la",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 12500, "rate": 0.0185 },
              { "min": 12501, "max": 50000, "rate": 0.035 },
              { "min": 50001, "max": 999999999, "rate": 0.0425 }
            ]
          },
          "cities": {
            "new-orleans": {
              "name": "New Orleans",
              "slug": "new-orleans",
              "coordinates": { "lat": 29.9511, "lon": -90.0715 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 101,
              "content": {
                "intro": "New Orleans, the Crescent City, is a cultural treasure known for its jazz music, Creole cuisine, and vibrant festivals. With a low cost of living and a growing tech and film industry, New Orleans offers a unique lifestyle that few American cities can match.",
                "fun_fact": "New Orleans hosts Mardi Gras, one of the largest celebrations in the world, and the city's French Quarter is a National Historic Landmark. Louisiana's film tax credits have made New Orleans 'Hollywood South,' producing more films than any state except California and New York.",
                "hiring_stats": "The median household income in New Orleans is approximately $45,000, with major employment in tourism, film production, energy, healthcare, port operations, and a growing technology sector."
              },
              "nearby_cities": ["baton-rouge"]
            },
            "baton-rouge": {
              "name": "Baton Rouge",
              "slug": "baton-rouge",
              "coordinates": { "lat": 30.4515, "lon": -91.1871 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 93,
              "content": {
                "intro": "Baton Rouge, Louisiana's capital and home to LSU, is a major petrochemical and government hub on the Mississippi River. With an extremely affordable cost of living and stable government employment, Baton Rouge offers solid financial value for professionals.",
                "fun_fact": "Baton Rouge is home to the world's largest state capitol building in the United States at 450 feet, built by Huey Long in 1932. The city's petrochemical corridor along the Mississippi is one of the largest in the world.",
                "hiring_stats": "The median household income in Baton Rouge is approximately $48,000, with major employment in state government, petrochemicals, higher education, healthcare, and technology."
              },
              "nearby_cities": ["new-orleans"]
            }
          }
        },
        "ky": {
          "name": "Kentucky",
          "slug": "ky",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.04 }
            ]
          },
          "cities": {
            "louisville": {
              "name": "Louisville",
              "slug": "louisville",
              "coordinates": { "lat": 38.2527, "lon": -85.7585 },
              "local_tax_rate": 0.0225,
              "cost_of_living_index": 93,
              "content": {
                "intro": "Louisville, Kentucky's largest city and home of the Kentucky Derby, is a major logistics, healthcare, and bourbon hub. With a low state tax rate and an affordable cost of living, Louisville offers strong take-home pay for professionals in a city rich with culture and Southern hospitality.",
                "fun_fact": "Louisville is home to the world's largest bourbon distillery — the Brown-Forman distillery — and the city's bourbon trail features over 40 bars and restaurants. UPS's global air hub at Louisville's airport makes it a logistics powerhouse.",
                "hiring_stats": "The median household income in Louisville is approximately $55,000, with major employment in logistics (UPS), healthcare (Humana), bourbon distilling, manufacturing, and food and beverage."
              },
              "nearby_cities": ["lexington"]
            },
            "lexington": {
              "name": "Lexington",
              "slug": "lexington",
              "coordinates": { "lat": 38.0406, "lon": -84.5037 },
              "local_tax_rate": 0.025,
              "cost_of_living_index": 95,
              "content": {
                "intro": "Lexington, the Horse Capital of the World, is a thriving university city surrounded by iconic bluegrass horse farms. Home to the University of Kentucky, Lexington offers a high quality of life with affordable living and a growing technology sector.",
                "fun_fact": "Lexington is surrounded by over 450 horse farms and is the center of the thoroughbred horse industry. The city's bourbon trail and horse country attract visitors from around the world.",
                "hiring_stats": "The median household income in Lexington is approximately $58,000, with strong employment in higher education, healthcare, equine industry, technology, manufacturing, and automotive (Toyota)."
              },
              "nearby_cities": ["louisville"]
            }
          }
        },
        "sc": {
          "name": "South Carolina",
          "slug": "sc",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 3200, "rate": 0.0 },
              { "min": 3201, "max": 16040, "rate": 0.03 },
              { "min": 16041, "max": 999999999, "rate": 0.064 }
            ]
          },
          "cities": {
            "charleston": {
              "name": "Charleston",
              "slug": "charleston",
              "coordinates": { "lat": 32.7765, "lon": -79.9311 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 112,
              "content": {
                "intro": "Charleston, one of America's most charming and historic cities, has evolved into a booming tech and aerospace hub. With beautiful architecture, world-class dining, and a growing economy, Charleston attracts professionals seeking Southern charm with modern career opportunities.",
                "fun_fact": "Charleston is the healthcare capital of the United States, with over 500 healthcare companies headquartered in the metro area, including HCA Healthcare, the largest private hospital operator in the world.",
                "hiring_stats": "The median household income in Charleston is approximately $65,000, with growing sectors in aerospace (Boeing), technology, tourism, healthcare, military (Joint Base Charleston), and hospitality."
              },
              "nearby_cities": ["columbia"]
            },
            "columbia": {
              "name": "Columbia",
              "slug": "columbia",
              "coordinates": { "lat": 34.0007, "lon": -81.0348 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 95,
              "content": {
                "intro": "Columbia, South Carolina's capital and home to the University of South Carolina, is a growing government and military hub. With an extremely affordable cost of living and stable employment, Columbia offers solid financial value for professionals.",
                "fun_fact": "Columbia is home to the Congaree National Park, which contains some of the tallest trees in the eastern United States, and Fort Jackson, the US Army's largest basic training installation.",
                "hiring_stats": "The median household income in Columbia is approximately $48,000, with major employment in state government, military, higher education, healthcare, insurance, and banking."
              },
              "nearby_cities": ["charleston"]
            }
          }
        },
        "va": {
          "name": "Virginia",
          "slug": "va",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 3000, "rate": 0.02 },
              { "min": 3001, "max": 5000, "rate": 0.03 },
              { "min": 5001, "max": 17000, "rate": 0.05 },
              { "min": 17001, "max": 999999999, "rate": 0.0575 }
            ]
          },
          "cities": {
            "richmond": {
              "name": "Richmond",
              "slug": "richmond",
              "coordinates": { "lat": 37.5407, "lon": -77.4360 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 102,
              "content": {
                "intro": "Richmond, Virginia's capital, is a historic city with a rapidly modernizing economy. With a moderate cost of living, growing tech scene, and rich cultural heritage, Richmond offers professionals a balanced lifestyle between the mountains and the coast.",
                "fun_fact": "Richmond is the only city in the US with Class III and IV whitewater rapids running through its downtown. The city's craft beer scene, historic architecture, and vibrant arts district have made it one of the South's coolest cities.",
                "hiring_stats": "The median household income in Richmond is approximately $52,000, with strong employment in finance (Capital One), government, healthcare, higher education, and a growing technology sector."
              },
              "nearby_cities": ["virginia-beach", "arlington"]
            },
            "virginia-beach": {
              "name": "Virginia Beach",
              "slug": "virginia-beach",
              "coordinates": { "lat": 36.8529, "lon": -75.9780 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 105,
              "content": {
                "intro": "Virginia Beach, the most populous city in Virginia, combines a resort-town lifestyle with a strong military and defense economy. With beautiful beaches and a moderate cost of living, Virginia Beach offers an attractive quality of life for professionals.",
                "fun_fact": "Virginia Beach holds the Guinness World Record for the longest pleasure beach in the world at 35 miles. The city is also home to Naval Air Station Oceana, one of the largest naval air installations in the world.",
                "hiring_stats": "The median household income in Virginia Beach is approximately $76,000, with major employment in military and defense, tourism, agriculture, healthcare, and technology."
              },
              "nearby_cities": ["richmond", "arlington"]
            },
            "arlington": {
              "name": "Arlington",
              "slug": "arlington",
              "coordinates": { "lat": 38.8816, "lon": -77.0910 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 155,
              "content": {
                "intro": "Arlington, located directly across the Potomac River from Washington DC, is one of the wealthiest and most educated communities in America. Home to the Pentagon and Amazon's HQ2, Arlington offers exceptional career opportunities in government, defense, and technology.",
                "fun_fact": "Arlington is home to the Pentagon, Arlington National Cemetery, and Amazon's second headquarters (HQ2). Despite being a county, not a city, it has a higher population density than most US cities.",
                "hiring_stats": "The median household income in Arlington exceeds $125,000, with dominant employment in federal government, defense contracting, technology (Amazon HQ2), consulting, and professional services."
              },
              "nearby_cities": ["richmond", "virginia-beach"]
            }
          }
        },
        "md": {
          "name": "Maryland",
          "slug": "md",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 1000, "rate": 0.02 },
              { "min": 1001, "max": 2000, "rate": 0.03 },
              { "min": 2001, "max": 3000, "rate": 0.04 },
              { "min": 3001, "max": 100000, "rate": 0.0475 },
              { "min": 100001, "max": 125000, "rate": 0.05 },
              { "min": 125001, "max": 150000, "rate": 0.0525 },
              { "min": 150001, "max": 250000, "rate": 0.055 },
              { "min": 250001, "max": 999999999, "rate": 0.0575 }
            ]
          },
          "cities": {
            "baltimore": {
              "name": "Baltimore",
              "slug": "baltimore",
              "coordinates": { "lat": 39.2904, "lon": -76.6122 },
              "local_tax_rate": 0.032,
              "cost_of_living_index": 108,
              "content": {
                "intro": "Baltimore, Maryland's largest city, is a major healthcare, biotech, and port city with deep historical roots. While Baltimore's combined state and local tax burden is notable, the city's affordable housing compared to nearby DC and strong job market in healthcare make it an attractive option for professionals.",
                "fun_fact": "Baltimore is home to Johns Hopkins University and Hospital, consistently ranked among the best in the world. The city's Inner Harbor was one of the first major urban waterfront renewal projects in the US and remains a top tourist destination.",
                "hiring_stats": "The median household income in Baltimore is approximately $54,000, with major employment in healthcare (Johns Hopkins), biotechnology, cybersecurity, port operations, higher education, and defense."
              },
              "nearby_cities": []
            }
          }
        },
        "id": {
          "name": "Idaho",
          "slug": "id",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 999999999, "rate": 0.058 }
            ]
          },
          "cities": {
            "boise": {
              "name": "Boise",
              "slug": "boise",
              "coordinates": { "lat": 43.6150, "lon": -116.2023 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 107,
              "content": {
                "intro": "Boise, Idaho's capital, has emerged as one of America's fastest-growing cities, attracting tech workers and outdoor enthusiasts from more expensive West Coast cities. With a moderate cost of living and access to world-class outdoor recreation, Boise offers an exceptional quality of life.",
                "fun_fact": "Boise has more than 190 miles of hiking and biking trails in the foothills, and the Boise River Greenbelt runs 25 miles through the heart of the city. Micron Technology, one of the world's largest semiconductor companies, is headquartered here.",
                "hiring_stats": "The median household income in Boise is approximately $62,000, with growing sectors in technology (Micron, HP), healthcare, outdoor recreation, agriculture, and government."
              },
              "nearby_cities": []
            }
          }
        },
        "ne": {
          "name": "Nebraska",
          "slug": "ne",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 3700, "rate": 0.0246 },
              { "min": 3701, "max": 22170, "rate": 0.0351 },
              { "min": 22171, "max": 35730, "rate": 0.0501 },
              { "min": 35731, "max": 999999999, "rate": 0.0584 }
            ]
          },
          "cities": {
            "omaha": {
              "name": "Omaha",
              "slug": "omaha",
              "coordinates": { "lat": 41.2565, "lon": -95.9345 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 92,
              "content": {
                "intro": "Omaha, Nebraska's largest city and home of Warren Buffett's Berkshire Hathaway, is a major financial and insurance hub. With an extremely affordable cost of living and a surprisingly diverse economy, Omaha offers excellent value for professionals seeking Midwest stability with big-city opportunities.",
                "fun_fact": "Omaha is home to five Fortune 500 companies, including Berkshire Hathaway, Mutual of Omaha, and Union Pacific Railroad. The city's annual Berkshire Hathaway shareholders meeting draws over 40,000 investors from around the world.",
                "hiring_stats": "The median household income in Omaha is approximately $60,000, with major employment in finance, insurance, telecommunications, food processing (ConAgra), transportation, and technology."
              },
              "nearby_cities": []
            }
          }
        },
        "mo": {
          "name": "Missouri",
          "slug": "mo",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 1207, "rate": 0.02 },
              { "min": 1208, "max": 2414, "rate": 0.025 },
              { "min": 2415, "max": 3621, "rate": 0.03 },
              { "min": 3622, "max": 4828, "rate": 0.035 },
              { "min": 4829, "max": 6035, "rate": 0.04 },
              { "min": 6036, "max": 7242, "rate": 0.045 },
              { "min": 7243, "max": 8449, "rate": 0.05 },
              { "min": 8450, "max": 999999999, "rate": 0.0495 }
            ]
          },
          "cities": {
            "kansas-city": {
              "name": "Kansas City",
              "slug": "kansas-city",
              "coordinates": { "lat": 39.0997, "lon": -94.5786 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 96,
              "content": {
                "intro": "Kansas City, straddling the Missouri-Kansas border, is a major hub for barbecue, jazz, and a growing tech scene. With an extremely affordable cost of living and a diverse economy, KC offers professionals strong purchasing power and a high quality of life.",
                "fun_fact": "Kansas City has more barbecue restaurants per capita than any other US city and more fountains than any city except Rome. The city's jazz heritage is celebrated in the historic 18th & Vine district.",
                "hiring_stats": "The median household income in Kansas City is approximately $58,000, with major employment in healthcare, technology, finance, government, automotive manufacturing, and agriculture."
              },
              "nearby_cities": ["st-louis"]
            },
            "st-louis": {
              "name": "St. Louis",
              "slug": "st-louis",
              "coordinates": { "lat": 38.6270, "lon": -90.1994 },
              "local_tax_rate": 0.01,
              "cost_of_living_index": 90,
              "content": {
                "intro": "St. Louis, the Gateway to the West, is a major healthcare, biotech, and manufacturing hub on the Mississippi River. With one of the lowest costs of living among major US cities, St. Louis offers exceptional value — your salary stretches remarkably far here.",
                "fun_fact": "The Gateway Arch in St. Louis is the tallest man-made monument in the United States at 630 feet. The city is also home to Anheuser-Busch, the world's largest brewing company, and a thriving biotech corridor.",
                "hiring_stats": "The median household income in St. Louis is approximately $47,000, with major employment in healthcare (BJC, Washington University), biotechnology, manufacturing, financial services, and defense (Boeing)."
              },
              "nearby_cities": ["kansas-city"]
            }
          }
        },
        "ok": {
          "name": "Oklahoma",
          "slug": "ok",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 1000, "rate": 0.0025 },
              { "min": 1001, "max": 2500, "rate": 0.0075 },
              { "min": 2501, "max": 3750, "rate": 0.0175 },
              { "min": 3751, "max": 4900, "rate": 0.0275 },
              { "min": 4901, "max": 7200, "rate": 0.0375 },
              { "min": 7201, "max": 999999999, "rate": 0.0475 }
            ]
          },
          "cities": {
            "oklahoma-city": {
              "name": "Oklahoma City",
              "slug": "oklahoma-city",
              "coordinates": { "lat": 35.4676, "lon": -97.5164 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 89,
              "content": {
                "intro": "Oklahoma City, the state capital, is a major energy and aerospace hub with one of the lowest costs of living among US metro areas. With a moderate tax rate and affordable housing, OKC offers professionals exceptional purchasing power and a growing quality of life.",
                "fun_fact": "Oklahoma City has undergone a massive urban renaissance through its MAPS program, investing billions in downtown revitalization including the Bricktown entertainment district, a new streetcar system, and the Paycom Center arena.",
                "hiring_stats": "The median household income in Oklahoma City is approximately $55,000, with major employment in energy, aerospace (Tinker Air Force Base), healthcare, government, and technology."
              },
              "nearby_cities": ["tulsa"]
            },
            "tulsa": {
              "name": "Tulsa",
              "slug": "tulsa",
              "coordinates": { "lat": 36.1540, "lon": -115.9928 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 87,
              "content": {
                "intro": "Tulsa, Oklahoma's second-largest city, has reinvented itself from an oil capital into a remote work destination with its famous Tulsa Remote program. With an extremely low cost of living and growing tech scene, Tulsa offers outstanding financial value.",
                "fun_fact": "Tulsa's Gathering Place, a 66-acre public park, was named the best new attraction in the US by USA Today. The city's Tulsa Remote program pays remote workers $10,000 to relocate, attracting tech talent from across the country.",
                "hiring_stats": "The median household income in Tulsa is approximately $48,000, with major employment in energy, aerospace, healthcare, finance, and a rapidly growing remote work and technology sector."
              },
              "nearby_cities": ["oklahoma-city"]
            }
          }
        },
        "nm": {
          "name": "New Mexico",
          "slug": "nm",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 5500, "rate": 0.017 },
              { "min": 5501, "max": 11000, "rate": 0.032 },
              { "min": 11001, "max": 16000, "rate": 0.047 },
              { "min": 16001, "max": 210000, "rate": 0.049 },
              { "min": 210001, "max": 999999999, "rate": 0.059 }
            ]
          },
          "cities": {
            "albuquerque": {
              "name": "Albuquerque",
              "slug": "albuquerque",
              "coordinates": { "lat": 35.0844, "lon": -106.6504 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 95,
              "content": {
                "intro": "Albuquerque, New Mexico's largest city, is a unique blend of Native American, Hispanic, and Anglo cultures set against stunning desert landscapes. With an affordable cost of living and growing tech and film industries, Albuquerque offers a distinctive lifestyle for professionals.",
                "fun_fact": "Albuquerque hosts the world's largest hot air balloon festival — the Albuquerque International Balloon Fiesta — with over 500 balloons launching each October. The city is also a major hub for Sandia National Laboratories and the film industry (Breaking Bad was filmed here).",
                "hiring_stats": "The median household income in Albuquerque is approximately $55,000, with major employment in national laboratories (Sandia, Los Alamos), film production, healthcare, military (Kirtland AFB), and technology."
              },
              "nearby_cities": ["santa-fe"]
            },
            "santa-fe": {
              "name": "Santa Fe",
              "slug": "santa-fe",
              "coordinates": { "lat": 35.6870, "lon": -105.9378 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 112,
              "content": {
                "intro": "Santa Fe, the oldest state capital in the US, is a world-renowned arts and culture destination. With its distinctive adobe architecture, thriving gallery scene, and growing creative economy, Santa Fe attracts artists, writers, and professionals seeking an inspiring lifestyle.",
                "fun_fact": "Santa Fe has the third-largest art market in the United States after New York and Los Angeles, with over 250 galleries. The city's Canyon Road is one of the most famous art walks in the world.",
                "hiring_stats": "The median household income in Santa Fe is approximately $58,000, with major employment in state government, tourism, arts and culture, healthcare, higher education, and hospitality."
              },
              "nearby_cities": ["albuquerque"]
            }
          }
        },
        "hi": {
          "name": "Hawaii",
          "slug": "hi",
          "state_tax": {
            "brackets": [
              { "min": 0, "max": 2400, "rate": 0.014 },
              { "min": 2401, "max": 4800, "rate": 0.032 },
              { "min": 4801, "max": 9600, "rate": 0.055 },
              { "min": 9601, "max": 14400, "rate": 0.064 },
              { "min": 14401, "max": 19200, "rate": 0.068 },
              { "min": 19201, "max": 24000, "rate": 0.072 },
              { "min": 24001, "max": 36000, "rate": 0.076 },
              { "min": 36001, "max": 48000, "rate": 0.079 },
              { "min": 48001, "max": 150000, "rate": 0.0825 },
              { "min": 150001, "max": 175000, "rate": 0.09 },
              { "min": 175001, "max": 200000, "rate": 0.10 },
              { "min": 200001, "max": 999999999, "rate": 0.11 }
            ]
          },
          "cities": {
            "honolulu": {
              "name": "Honolulu",
              "slug": "honolulu",
              "coordinates": { "lat": 21.3069, "lon": -157.8583 },
              "local_tax_rate": 0.0,
              "cost_of_living_index": 192,
              "content": {
                "intro": "Honolulu, the capital of Hawaii, offers a tropical paradise lifestyle with a unique tax situation. While Hawaii has one of the highest state income tax rates in the nation, the island lifestyle and military presence create a distinctive employment landscape.",
                "fun_fact": "Honolulu is the only major US city located in the tropics and is home to Pearl Harbor, one of the most significant military installations in the Pacific. The city's Waikiki Beach attracts over 4 million visitors annually.",
                "hiring_stats": "The median household income in Honolulu is approximately $88,000, with major employment in military and defense, tourism, healthcare, government, and real estate."
              },
              "nearby_cities": []
            }
          }
        }
      }
    },
    "uk": {
      "name": "United Kingdom",
      "slug": "uk",
      "currency": "GBP",
      "currency_symbol": "£",
      "tax_system": "national_insurance",
      "income_tax": {
        "brackets": [
          { "min": 0, "max": 8500, "rate": 0.0 },
          { "min": 8501, "max": 11700, "rate": 0.20 },
          { "min": 11701, "max": 13900, "rate": 0.40 },
          { "min": 13901, "max": 999999999, "rate": 0.45 }
        ],
        "personal_allowance": 12570
      },
      "national_insurance": {
        "brackets": [
          { "min": 0, "max": 12570, "rate": 0.0 },
          { "min": 12571, "max": 50270, "rate": 0.12 },
          { "min": 50271, "max": 999999999, "rate": 0.02 }
        ]
      },
      "regions": {
        "london": {
          "name": "London",
          "slug": "london",
          "coordinates": { "lat": 51.5074, "lon": -0.1278 },
          "local_tax_rate": 0.0,
          "cost_of_living_index": 165,
          "content": {
            "intro": "London, the capital of the United Kingdom, is a global financial center with diverse employment opportunities. Understanding your take-home pay helps you navigate one of Europe's most expensive cities.",
            "fun_fact": "London is home to the London Stock Exchange, numerous multinational corporations, and a thriving tech startup scene in areas like Shoreditch and King's Cross.",
            "hiring_stats": "The median salary in London is approximately £45,000, significantly higher than the UK average, with strong sectors including finance, technology, creative industries, and professional services."
          },
          "nearby_cities": ["manchester", "birmingham"]
        },
        "manchester": {
          "name": "Manchester",
          "slug": "manchester",
          "coordinates": { "lat": 53.4808, "lon": -2.2426 },
          "local_tax_rate": 0.0,
          "cost_of_living_index": 98,
          "content": {
            "intro": "Manchester, the powerhouse of Northern England, has transformed from its industrial roots into a thriving digital and creative hub. With a cost of living significantly lower than London, Manchester offers excellent value for professionals — your pound goes much further here.",
            "fun_fact": "Manchester is where the modern computer was born — Alan Turing and his team built the first stored-program computer at the University of Manchester in 1948. The city is also home to two of the world's most famous football clubs.",
            "hiring_stats": "The median salary in Manchester is approximately £32,000, with rapidly growing sectors in digital technology, media (BBC and ITV have major studios here), financial services, and creative industries."
          },
          "nearby_cities": ["london", "birmingham"]
        },
        "birmingham": {
          "name": "Birmingham",
          "slug": "birmingham",
          "coordinates": { "lat": 52.4862, "lon": -1.8904 },
          "local_tax_rate": 0.0,
          "cost_of_living_index": 92,
          "content": {
            "intro": "Birmingham, the UK's second-largest city, is undergoing a massive regeneration and economic transformation. With the lowest cost of living among major UK cities and improving transport links via HS2, Birmingham offers outstanding financial value for professionals.",
            "fun_fact": "Birmingham has more miles of canals than Venice and was the birthplace of the Industrial Revolution. Today, the city's Jewellery Quarter produces 40% of all jewellery made in the UK.",
            "hiring_stats": "The median salary in Birmingham is approximately £30,000, with strong employment in automotive manufacturing (Jaguar Land Rover), financial services, professional services, and a growing tech sector."
          },
          "nearby_cities": ["london", "manchester"]
        }
      }
    }
  }
}
